import React, { useState } from "react";
import CancelSignalModal from "features/signals/CancelSignal/CancelSignalModal";

interface CancelSignalProps {
  trigger: React.JSX.Element;
  signalId: number;
}

// Passing props through to trigger component is required for antd trigger components to work properly
// (for example, MenuItem)
const CancelSignalTrigger = ({
  trigger,
  signalId,
  ...props
}: CancelSignalProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {React.cloneElement(trigger, {
        ...props,
        onClick: () => {
          (props as any).onClick && (props as any).onClick();
          setModalOpen(true);
        },
      })}
      <CancelSignalModal
        signalId={signalId}
        closeModal={() => setModalOpen(false)}
        visible={modalOpen}
      />
    </>
  );
};

export default CancelSignalTrigger;
